import { render, staticRenderFns } from "./TestForm.vue?vue&type=template&id=90929a78&"
import script from "./TestForm.vue?vue&type=script&lang=js&"
export * from "./TestForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/production/spf-sexosafe-ezplatform/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90929a78')) {
      api.createRecord('90929a78', component.options)
    } else {
      api.reload('90929a78', component.options)
    }
    module.hot.accept("./TestForm.vue?vue&type=template&id=90929a78&", function () {
      api.rerender('90929a78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/TestForm/TestForm.vue"
export default component.exports